export const features = [
  {
    icon: 'Brain',
    title: 'Semantic Memory Store',
    description: 'Embeddings-backed long-term memory with relevance scoring for intelligent recall.',
  },
  {
    icon: 'Camera',
    title: 'Session Snapshots',
    description: 'Capture complete agent state — conversation history, tool results, mid-computation variables.',
  },
  {
    icon: 'ArrowLeftRight',
    title: 'Cross-Provider Continuity',
    description: 'Transfer context between Claude, GPT, and Gemini seamlessly mid-workflow.',
  },
  {
    icon: 'Search',
    title: 'Memory Query API',
    description: 'Retrieve relevant past context given current task description using natural language.',
  },
  {
    icon: 'GitMerge',
    title: 'Conflict Resolution',
    description: 'Handle concurrent writes from multiple agents with optimistic locking.',
  },
  {
    icon: 'Plug',
    title: 'Pluggable Backends',
    description: 'Redis, SQLite, S3, Postgres — choose your storage layer without changing agent code.',
  },
];
